<template>
  <div class="uk-modal-dialog uk-margin-auto-vertical">
    <div class="uk-modal-body">
      <Form @submit="onBeforeSubmit" :validation-schema="validationSchema" ref="email-template-form" :initial-values="formValues">
        <div class="uk-modal-header form-header">
          <div class="uk-text-bold uk-text-large">
            {{ mailTemplate && mailTemplate.emailTemplateId ? "メールテンプレート編集" : "メールテンプレート作成" }}
          </div>
        </div>
        <div class="uk-modal-body">
          <FormError :errors="globalErrors" />
          <div class="field">
            <Field name="name" v-slot="{ field }">
              <FieldLabel title="テンプレート名" :required="true" />
              <input class="uk-input" type="text" v-bind="field" />
            </Field>
            <FieldError name="name" />
          </div>
          <div class="field">
            <Field name="message" v-slot="{ field }">
              <FieldLabel title="テンプレート本文" :required="true" />
              <div>以下の変数が利用できます。</div>
              <table class="uk-table uk-table-divider uk-table-justify uk-table-small">
                <thead>
                  <tr>
                    <th class="uk-width-small">変数</th>
                    <th>変換される内容</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>%name%</td>
                    <td>受検者の氏名に変換されます</td>
                  </tr>
                  <tr>
                    <td>%url%</td>
                    <td>個別の受検URLに変換されます</td>
                  </tr>
                  <tr>
                    <td>%survey_term%</td>
                    <td>
                      アセスメントサーベイグループの受検開始日時（JST）〜受検終了日時（JST）に変換されます<br />
                      例：2021/11/20 10:00 (JST)〜2021/11/26 18:00 (JST)
                    </td>
                  </tr>
                  <tr>
                    <td>%instructions_list%</td>
                    <td>推奨ブラウザや受検に関する注意事項に変換されます<br />注意事項の全文は、マニュアルに記載しております</td>
                  </tr>
                </tbody>
              </table>
              <div>
                <textarea class="uk-textarea" rows="7" v-bind="field" />
              </div>
            </Field>
            <FieldError name="message" />
          </div>
        </div>
        <div class="uk-modal-footer uk-text-right form-action">
          <div>
            <ActionButton title="戻る" class="uk-modal-close" toggleTarget=".email-template-form" />
          </div>
          <div class="form-action-main">
            <ActionButton title="確定" color="primary" type="submit" :disabled="processing" />
            <ActionButton v-if="mailTemplate" title="削除" @click="onDeleteButtonClick" color="warn" />
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@include modal-form;
div.uk-modal-dialog {
  width: 800px;
}
</style>
<script lang="ts">
import { Options } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Field, Form } from "vee-validate";
import FormMixin from "../../helpers/mixins/form";
import FieldLabel from "../atoms/FieldLabel.vue";
import * as yup from "yup";
import FieldError from "../atoms/FieldError.vue";
import FormError from "../atoms/FormError.vue";
import ActionButton from "@/components/atoms/ActionButton.vue";
import { SystemApi, EmailTemplateTypeEnum, GetEmailTemplate } from "../../autogen";

type FormValues = {
  name: string;
  message: string;
};

@Options({
  components: { Field, Form, FieldLabel, FieldError, FormError, ActionButton }
})
export default class EmailTemplateForm extends FormMixin {
  @Prop({ type: Object }) mailTemplate: GetEmailTemplate | null = null;
  globalErrors: { message: string }[] = [];
  formName = "メールテンプレート";
  formValues: FormValues = {
    name: "",
    message: ""
  };
  validationSchema!: yup.AnyObjectSchema;
  beforeCreate() {
    this.validationSchema = yup.object({
      name: yup
        .string()
        .trim()
        .required(this.$t("input_required", { field: "テンプレート名" })),
      message: yup
        .string()
        .trim()
        .required(this.$t("input_required", { field: "テンプレート本文" }))
    });
  }
  beforeMount() {
    if (this.mailTemplate) {
      this.formValues = {
        name: this.mailTemplate.name,
        message: this.mailTemplate.message
      };
    } else {
      this.formValues = {
        name: "",
        message: ""
      };
    }
  }
  async onBeforeSubmit(values: FormValues) {
    await this.onSubmit(async () => {
      if (this.mailTemplate) {
        await new SystemApi().updateEmailTemplate({
          emailTemplateId: this.mailTemplate.emailTemplateId,
          emailTemplateType: EmailTemplateTypeEnum.As,
          emailTemplateUpdate: values
        });
      } else {
        await new SystemApi().createEmailTemplate({
          emailTemplateCreate: Object.assign({ emailTemplateType: EmailTemplateTypeEnum.As }, values)
        });
      }
      this.$emit("submitted");
    });
  }
  async onDeleteButtonClick() {
    if (!this.mailTemplate) return;
    await this.onDelete(async () => {
      await new SystemApi().deleteEmailTemplate({
        emailTemplateId: this.mailTemplate!.emailTemplateId,
        emailTemplateType: EmailTemplateTypeEnum.As
      });
    });
  }
}
</script>
